"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLSelectionCollectionContext = exports.OLSelectionProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Collection_1 = __importDefault(require("ol/Collection"));
const condition_1 = require("ol/events/condition");
const DragBox_1 = __importDefault(require("ol/interaction/DragBox"));
const Select_1 = __importDefault(require("ol/interaction/Select"));
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function OLSelectionProvider({ children }) {
    const map = useOLMap_1.useOLMap();
    const selectedOLFeatures = react_1.useMemo(() => new Collection_1.default([]), []);
    const selectInteraction = react_1.useMemo(() => {
        return new Select_1.default({
            features: selectedOLFeatures,
            condition: condition_1.click,
            addCondition: condition_1.platformModifierKeyOnly,
            removeCondition: condition_1.platformModifierKeyOnly,
            style: false,
        });
    }, [selectedOLFeatures]);
    const selectWithBoxInteraction = react_1.useMemo(() => {
        return new DragBox_1.default({ condition: condition_1.shiftKeyOnly, className: 'openlayers-dragbox' });
    }, []);
    const element = map.getTargetElement();
    react_1.useEffect(() => {
        if (!element) {
            return () => { };
        }
        const keyDown = (e) => {
            if (e.key === 'Escape') {
                selectedOLFeatures.forEach(feature => feature.dispatchEvent('deselected'));
            }
        };
        element.addEventListener('keydown', keyDown);
        return () => {
            element.removeEventListener('keydown', keyDown);
        };
    }, [element, selectedOLFeatures]);
    react_1.useEffect(() => {
        const boxend = () => {
            const rotation = map.getView().getRotation();
            const candidateFeatures = [];
            const extent = selectWithBoxInteraction.getGeometry().getExtent();
            map.getLayers().forEach((layer) => {
                if ('getSource' in layer) {
                    const source = layer.getSource();
                    if ('forEachFeatureIntersectingExtent' in source) {
                        source.forEachFeatureIntersectingExtent(extent, feature => {
                            candidateFeatures.push(feature);
                        });
                    }
                }
            });
            const featuresInside = [];
            const anchor = [0, 0];
            const geometry = selectWithBoxInteraction.getGeometry().clone();
            geometry.rotate(-rotation, anchor);
            const extent$1 = geometry.getExtent();
            candidateFeatures.forEach(feature => {
                const geometry = feature.getGeometry().clone();
                geometry.rotate(-rotation, anchor);
                if (geometry.intersectsExtent(extent$1)) {
                    featuresInside.push(feature);
                }
            });
            featuresInside.forEach(feature => {
                feature.dispatchEvent('selected');
            });
        };
        selectWithBoxInteraction.on('boxend', boxend);
        return () => {
            selectWithBoxInteraction.un('boxend', boxend);
        };
    }, [selectWithBoxInteraction, map, selectedOLFeatures]);
    react_1.useEffect(() => {
        const onSelect = (e) => {
            e.deselected.forEach(feature => feature.dispatchEvent('deselected'));
            e.selected.forEach(feature => feature.dispatchEvent('selected'));
        };
        selectInteraction.on('select', onSelect);
        return () => {
            selectInteraction.un('select', onSelect);
        };
    }, [selectInteraction, selectedOLFeatures]);
    react_1.useEffect(() => {
        map.addInteraction(selectInteraction);
        return () => {
            map.removeInteraction(selectInteraction);
        };
    }, [map, selectInteraction]);
    react_1.useEffect(() => {
        map.addInteraction(selectWithBoxInteraction);
        return () => {
            map.removeInteraction(selectWithBoxInteraction);
        };
    });
    return (jsx_runtime_1.jsx(exports.OLSelectionCollectionContext.Provider, Object.assign({ value: selectedOLFeatures }, { children: children }), void 0));
}
exports.OLSelectionProvider = OLSelectionProvider;
exports.OLSelectionCollectionContext = react_1.createContext(new Collection_1.default());
//# sourceMappingURL=OLSelectionProvider.js.map